import React, { Component } from "react";

import {
  getSendArchive,
  getChildsByOrg
} from "../../utils/operations.js";
import { observer, inject } from "mobx-react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { api2ChildGetArchive, api2ChildSendArchive, api2PublicStorage } from "../../utils/operations";
import API from '../../utils/api';
import { toast } from 'react-toastify';

const today = new Date();
const currentYear = parseInt(today.getFullYear(), 0);

class SendArchive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: currentYear,
      data: {},
      children: [],
      search: "",
      child: 0,
      invoices: [],
      opendialog: false,
      error: "",
      send: false,
      snackBar: false
    };
  }

  componentDidMount() {
    if (!this.props.Auth.can('sendarchive')) return this.props.history.push("/children");
    this.props.Auth.snackBar = false;
    this.loadData();
  }

  loadData = async () => {
    let orgId = this.props.Auth.orgId;

    let res = await API.get(getChildsByOrg + orgId);

    let children = [];
    for (let item of res.data.resource) {
      children.push({
        textKey: item.firstname + " " + item.lastname,
        valueKey: item.id
      });
    }

    try {
      let org = await API.get(getSendArchive + `/${orgId}?related=organisations_by_org_id`);
      this.setState({ data: org.data, children });
    } catch (e) {
      // No record yet for this school — start with empty defaults
      this.setState({
        data: { director: '', text: '', org_id: orgId, id: null },
        children
      });
    }
  };

  clearData = async () => {
    this.setState({
      year: 2021,
      data: {},
      children: [],
      search: "",
      child: 0,
      invoices: [],
      opendialog: false,
      error: "",
      send: false,
      snackBar: false
    });

    await this.loadData();
  };

  sendData = async () => {
    try {
      await API.get(api2ChildSendArchive(this.state.child), {
        params: {
          year: this.state.year
        }
      });

      toast.success('Archive was sent successfully!')

      this.setState({
        snackBar: true
      });
    } catch (e) {
      if (e.response.data.error.message) {
        this.setState({
          error: e.response.data.error.message,
          opendialog: true
        });
      }
    }
  };

  changeYear = (event) => {
    const value = event.target.value;
    this.setState({ year: value });
    if (this.state.send) {
      setTimeout(() => {this.showPreview()}, 100)
    }
  };

  autoCompleteChild = value => {
    this.setState({ child: value.valueKey });
    if (this.state.send) {
      setTimeout(() => {this.showPreview()}, 100)
    }
  };

  base64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || "";
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  showPreview = async () => {
    try {
      let res_invoices = await API.get(api2ChildGetArchive(this.state.child), {
        params: {
          year: this.state.year
        }
      });

      this.setState({
        send: true,
        invoices: res_invoices.data
      });
    } catch (e) {
      if (e.response.data.error.message) {
        this.setState({
          error: e.response.data.error.message,
          opendialog: true
        });
      }
    }
  };

  saveData = async () => {
    try {
      let orgId = this.props.Auth.orgId;
      let payload = {
        director: this.state.data.director,
        text: this.state.data.text
      };

      if (this.state.data.id) {
        await API.patch(getSendArchive + "/" + this.state.data.id, payload);
      } else {
        // No record yet — create it
        let res = await API.post(getSendArchive, { resource: [{ ...payload, org_id: orgId }] });
        const created = res.data?.resource?.[0];
        this.setState(prev => ({ data: { ...prev.data, id: created?.id } }));
      }

      toast.success('Saved successfully!');
    } catch (e) {
      toast.error(e.response?.data?.message || 'Error saving');
    }
  };

  closeError = () => {
    this.setState({
      error: "Error happens",
      opendialog: false
    });
  };

  snackRequestClose = () => {
    this.setState({
      snackBar: false
    });
  };

  handleText = event => {
    let data = this.state.data;
    data[event.target.id] = event.target.value;
    this.setState({ data });
  };

  render() {
    const years = [];
    for (let i = 0; i < 6; i++) {
      years.push(currentYear - i);
    }

    return (
      <div style={{ maxWidth: 500, margin: "auto" }}>
        <div style={{ flex: 1 }}>
          <span style={{ color: "gray" }}>Select year:</span>
          <br />
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel>Year</InputLabel>
            <Select
              value={this.state.year}
              onChange={this.changeYear}
            >
              {years.map(y => (
                <MenuItem value={y} key={y}>{y}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <br />
          {this.state.children.length > 0 && (
            <Autocomplete
              options={this.state.children}
              getOptionLabel={(opt) => opt.textKey}
              onChange={(event, value) => value && this.autoCompleteChild(value)}
              renderInput={(params) => (
                <TextField {...params} label="Child (Firstname Lastname)" fullWidth sx={{ mt: 2 }} />
              )}
            />
          )}
        </div>
        {this.state.data && (
          <div>
            <TextField
              id="text"
              label="Mailing Text"
              fullWidth
              multiline
              rows={4}
              value={this.state.data.text || ''}
              onChange={this.handleText}
              sx={{ mt: 2, mb: 2 }}
            />
            <br />
            <TextField
              id="director"
              label="Director Name"
              fullWidth
              value={this.state.data.director || ''}
              onChange={this.handleText}
              sx={{ mb: 2 }}
            />
            <Button variant="contained" color="primary" onClick={this.saveData}>Save</Button>
          </div>
        )}
        <br />
        <div style={{ borderTopWidth: 1, borderColor: "gray" }}>
          <span style={{ color: "gray" }}>Year: {this.state.year}</span>
          <br />
          {this.state.invoices.length > 0 &&
            this.state.invoices.map((invoice, index) => (
              <div key={index}>
                <a
                  href={api2PublicStorage + invoice.invoicefile}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={require("../../images/pdf.jpg")} alt="Download PDF" />
                </a>
                &nbsp;&nbsp;&nbsp;
                {moment(invoice._created).format("MMMM")}
              </div>
            ))}
        </div>
        <br />
        {this.state.send ? (
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Button variant="contained" color="primary" onClick={this.sendData}>Send</Button>
            <Button variant="contained" color="secondary" onClick={this.clearData}>Clear</Button>
          </div>
        ) : (
          <Button variant="text" color="primary" onClick={this.showPreview}>Show Preview</Button>
        )}
        <br />
        <br />
        <br />

        <Dialog open={this.state.opendialog} onClose={this.closeError} maxWidth="xs">
          <DialogContent>{this.state.error}</DialogContent>
          <DialogActions>
            <Button onClick={this.closeError} color="primary">OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default inject("Auth")(observer(SendArchive))
